import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Form, Space, Result, Row, Col } from "antd";
import dayjs from "dayjs";
import { formatTransactionDate } from "../../../utils/sastDate";

import { useStepsForm } from "sunflower-antd";

import { AuthContext } from "../../../context/AuthContext";
import { getGroupApi } from "../../../services/Group/GroupApis";

interface IModalProps {
  show: boolean;
  receipt: any;
  showModal: Function;
  handleAdd: Function;
}

const FuneralReceiptModal: React.FC<IModalProps> = ({
  show,
  receipt,
  showModal,
}) => {
  const { currentGroup } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState("");
  const [group, setGroup] = useState<any>({});

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const handlePrint = () => {
    const printStyle = document.createElement("style");
    printStyle.innerHTML = `
      @media print {
        .ant-modal-content {
          box-shadow: none !important;
        }
        .ant-modal-close {
          display: none;
        }
        div.ant-modal-title {
          display: none;
        }
        button.ant-btn {
          display: none;
        }
      }
    `;
    document.head.appendChild(printStyle);

    // Trigger printing
    window.print();
  };

  useEffect(() => {
    const localeDate = new Date();
    const monthIndex = localeDate.getMonth();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthName = monthNames[monthIndex];
    const year = localeDate.getFullYear();

    setDate(`${monthName} ${year}`);
  }, []);

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      handlePrint();
      console.log("Printing Receipt");
    },
    total: 2,
  });

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 0 },
    wrapperCol: { offset: 8, span: 8 },
  };

  useEffect(() => {
    getGroupApi(currentGroup)
      .then((res) => {
        setGroup(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const formList: any = [
    <>
      <div style={{ textAlign: "center" }}>
        <img src={receipt.Group.CompanyLogo} alt="Logo" width={"25%"} />
        <h3>Cash Receipt</h3>
      </div>
      <Row
        style={{
          border: "1px solid black",
          width: "100%",
          marginBottom: "16px",
          padding: "6px",
        }}
      >
        {" "}
        <Col span={12}>
          <p>
            <strong>{receipt.Group.GroupName}</strong>
          </p>
          <p>{receipt.Group.AddressLine1}</p>
          <p>{receipt.Group.AddressLine2}</p>
          <p>{receipt.Group.Suburb}</p>
          <p>{receipt.Group.Province}</p>
        </Col>
        <Col>
          <p>{receipt.Group.Cellphone}</p>
          <p>{receipt.Group.Telephone}</p>
          <p>{receipt.Group.Email}</p>
          <p>{receipt.Group.CityTown}</p>
          <p>{receipt.Group.PostalCode}</p>
        </Col>
      </Row>

      <Row
        style={{
          border: "1px solid black",
          width: "100%",
          marginBottom: "16px",
          padding: "6px",
        }}
      >
        {" "}
        <Col span={12}>
          <p>
            <strong>Invoice Date</strong>
          </p>
          <p>{formatTransactionDate(receipt.Payment.Date)}</p>
          <p>
            <strong>Invoice No</strong>
          </p>
          <p>{receipt.InvoiceNumber}</p>
          <p>
            <strong>Name & Surname</strong>
          </p>
          <p>{`${receipt.FuneralCustomer.Name} ${receipt.FuneralCustomer.Surname}`}</p>
        </Col>
        <Col>
          <p>
            <strong>FSP NO</strong>
          </p>
          <p>{receipt.Group.FSPNumber}</p>
          <p>
            <strong>Reference</strong>
          </p>
          <p>{receipt.Payment.Reference}</p>
        </Col>
      </Row>

      <Row
        style={{
          border: "1px solid black",
          width: "100%",
          marginBottom: "16px",
          padding: "6px",
        }}
      >
        {" "}
        <Col span={20}>
          <p>{date}</p>
          <p>
            <strong>Total</strong>
          </p>
        </Col>
        <Col>
          <p>R {receipt.Payment.Amount}</p>
          <p>
            <strong>R {receipt.Payment.Amount}</strong>
          </p>
        </Col>
      </Row>

      <div style={{ textAlign: "center", marginBottom: "16px" }}>
        {/* <p>
          Lorem ipsum dolor sit amet. Et vero sint est aspernatur distinctio nam
          illum aliquam. Ad delectus illo sed eveniet recusandae eos expedita
          repellat qui assumenda galisum.
        </p>
        <p>
          Non quia quaerat nam galisum dolores id tenetur sunt sit voluptas
          nihil et Quis earum. Est accusamus voluptas et officia consequatur ab
          maxime odit.
        </p> */}
        <h4>Thank you for your business.</h4>
      </div>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            loading={loading}
            style={{ marginBottom: 10 }}
            block
            size="large"
            onClick={() => {
              submit().then((result: any) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Print Receipt
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="Payment Receipt"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={900}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {formList[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully printed.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title="Error occurred, please try again.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FuneralReceiptModal;
